import { joinPath } from '../../core/utils';
import type { BareMetalProvisioningPaths } from './types';

/** 按 pathPrefix 生成表单路径 */
export function resolveBareMetalProvisioningPaths(prefix: string): BareMetalProvisioningPaths {
  return {
    provisioningMode: joinPath(prefix, 'provisioning.mode'),
    bootMode: joinPath(prefix, 'boot.mode'),
    systemArchitecture: joinPath(prefix, 'systemVolume.architecture'),
    systemOs: joinPath(prefix, 'systemVolume.os'),
    systemVersion: joinPath(prefix, 'systemVolume.version'),
    accountPasswd: joinPath(prefix, 'account.passwd'),
    accountPrivatedKey: joinPath(prefix, 'account.privatedKey'),
  };
}
